import Image from 'next/image';
import IcHelp from '../images/icon-help.png';
import IcHistory from '../images/icon-history.png';
import { showHistoryStatisticDrawer } from '../modal';
import { useGullakLogin } from '../hooks/use-gullak-login';
import { track } from '@/utils/track';

export interface SettingGroupProps {
  handleShowRuleDrawer: () => any;
}

export default function SettingGroup({ handleShowRuleDrawer }: SettingGroupProps) {
  const { checkLoginAndExecute } = useGullakLogin();

  const handleClickHelp = () => {
    track('gullak_page_button_click', { button_name: 'Rules' });
    handleShowRuleDrawer();
  };

  const handleClickHistory = () => {
    checkLoginAndExecute(() => {
      track('gullak_page_button_click', { button_name: 'Gullak History' });
      showHistoryStatisticDrawer();
    });
  };

  return (
    <div className='absolute top-[7.8vw] left-4 z-30 flex items-center space-x-6'>
      <Image src={IcHelp.src} width={17} height={17} alt='help' className='active:scale-90' onClick={handleClickHelp} />
      <Image src={IcHistory.src} width={20} height={20} alt='history' className='active:scale-90' onClick={handleClickHistory} />
    </div>
  );
}